import styled from "styled-components";

export const BorderButton = styled.button`
	background: transparent;
	border: 1px solid #504c9a;
	padding: 8px 48px;
	color: #504c9a;
	font-size: 16px;
	line-height: 23px;
	font-weight: bold;
	border-radius: 8px;
`;
